<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="100%"
    max-height="90%"
    width="1350px"
    v-model="dialog"
    persistent
  >
    <v-card v-if="dialog" style="height: 85vh; width:100%; overflow: hidden;">
      <v-toolbar color="primary" dark>
        {{ transactionId }}
        <v-spacer></v-spacer>
        <v-btn text @click="close">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="height:100%; width:100%;">
        <div v-if="type === 'pdf'">
          <PdfViewer :url="url" />
        </div>
        <div v-else-if="type === 'image'" class="text-center">
          <img
            :src="url"
            alt="document image"
            style="border: 1px solid black;"
          />
        </div>
        <div v-else style="height:100%; width:100%">
          <iframe
            style="height:95%;width:100%"
            height="100%"
            width="100%"
            :src="`https://docs.google.com/gview?url=${url}&embedded=true`"
            frameborder="0"
          >
          </iframe>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import PdfViewer from "./PdfViewer";

  export default {
    name: "DocumentViewerDialog",
    props: {
      type: String,
      url: String,
      dialog: Boolean,
      transactionId: String,
    },
    components: {
      PdfViewer,
    },
    methods: {
      close() {
        this.$emit("closeDialog", false);
      },
    },
    watch: {
      dialog() {
        if (this.dialog) {
          console.log(this.type);
          console.log(this.url);
          console.log(this.transactionId);
        }
      },
    },
  };
</script>

<style></style>
